var path = 'batch/bulkRestore/details/bulkRestoreDetails.tpl.html';
var html = "<react-component name='activity-restore-table' />\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;